import { useEffect, useState } from "react";
import { api } from "./apiClient";

export const CURRENCIES = [
  { code: "GBP", label: "British Pound", symbol: "£" },
  { code: "USD", label: "US Dollar", symbol: "$" },
  { code: "EUR", label: "Euro", symbol: "€" },
  { code: "AUD", label: "Australian Dollar", symbol: "A$" },
  { code: "CAD", label: "Canadian Dollar", symbol: "C$" },
  { code: "NZD", label: "New Zealand Dollar", symbol: "NZ$" },
];

let _ratesCache = null;

export function useFxRates() {
  const [rates, setRates] = useState(_ratesCache);
  useEffect(() => {
    if (_ratesCache) return;
    api.get("/fx/rates")
      .then((res) => { _ratesCache = res.data.rates; setRates(res.data.rates); })
      .catch(() => {});
  }, []);
  return rates;
}

// Convert a GBP amount into the chosen display currency. Display-only — billing is always GBP.
export function convert(amountGBP, currency, rates) {
  const cur = (currency || "GBP").toUpperCase();
  if (cur === "GBP" || !rates || !rates[cur]) return { text: `£${amountGBP}`, isConverted: false, code: "GBP" };
  const val = amountGBP * rates[cur];
  const text = new Intl.NumberFormat(undefined, { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(val);
  return { text, isConverted: true, code: cur };
}
